import React from 'react'
import "./AboutBanner.css"
import AboutBannerCards from './about_banner_cards/AboutBannerCards'
import About_Banner_Component from './About_Banner_Component/About_Banner_Component'

export default function AboutBanner() {
    return (
        <section className='about-banner'>

            <About_Banner_Component
                img="\assets\Image\aboutus\about-banner\AboutBanner.png"
                title="About Us"
                subtext1="We help you providing financial advise."
                subtext2="Leave money issue with us and focus on your goals!"
                showBtn={true}
            />

            <div className='card-holder'>
                <div className='container'>
                    <div className=' row justify-content-center'>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 custom_col'>
                            <AboutBannerCards img="/assets/Image/aboutus/about-banner-cards/transparency.png" text="Service with Transparency" />
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 custom_col'>
                            <AboutBannerCards img="/assets/Image/aboutus/about-banner-cards/img2.png" text="Great Support" />
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 custom_col'>
                            <AboutBannerCards img="/assets/Image/aboutus/about-banner-cards/img3.png" text="Hassle Free Procedure" />
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 custom_col'>
                            <AboutBannerCards img="/assets/Image/aboutus/about-banner-cards/img4.png" text="Safe and Secure" />
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-4 col-6 custom_col'>
                            <AboutBannerCards img="/assets/Image/aboutus/about-banner-cards/img5.png" text="Fast Loan Approval" />
                        </div>

                    </div>

                </div>
            </div>
        </section>
    )
}
